import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { ErrorAlert } from '@/components/ErrorAlert';
import { LoadingIcon } from '@/components/LoadingIcon';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AiPhoneCallsTable } from '@/features/ai-phone-calls/AiPhoneCallsTable';
import { useFeatureFlagEnabled } from '@/features/feature-flags/useFeatureFlagEnabled';

export const Route = createFileRoute('/r/$restaurantId/phone-calls/')({
  component: PhoneCallListPage,
});

/** Calls to the venue's AI phone number, newest first (`ai-phone-ordering` flag). */
function PhoneCallListPage() {
  const { restaurantId } = Route.useParams();
  const isAiPhoneOrderingOn = useFeatureFlagEnabled(restaurantId, 'ai-phone-ordering');
  const callsQuery = useQuery(
    api.aiPhone.listCallsByRestaurantId,
    isAiPhoneOrderingOn ? { restaurantId } : 'skip',
  );

  if (!isAiPhoneOrderingOn) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Phone calls</CardTitle>
          <CardDescription>AI phone ordering isn't turned on for your venue.</CardDescription>
        </CardHeader>
      </Card>
    );
  }
  if (callsQuery.isPending) return <LoadingIcon />;
  if (callsQuery.isError) {
    return <ErrorAlert title="Error loading phone calls" message={callsQuery.error.message} />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Phone calls</CardTitle>
        <CardDescription>
          Calls to your AI phone number. Live calls update as the order is taken.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <AiPhoneCallsTable calls={callsQuery.data} showRestaurantColumn={false} />
      </CardContent>
    </Card>
  );
}
